var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * CalendarNumber component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconCalendarNumber extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.53809 1.10498C6.9523 1.10498 7.28809 1.44077 7.28809 1.85498V3.4458H16.7129V1.85498C16.7129 1.44077 17.0487 1.10498 17.4629 1.10498C17.8771 1.10498 18.2129 1.44077 18.2129 1.85498V3.4458H20.5848C21.1976 3.4458 21.7855 3.68924 22.2188 4.12265C22.652 4.55593 22.8956 5.14364 22.8956 5.75658V20.584C22.8956 21.1968 22.652 21.7847 22.2188 22.2179C21.7855 22.6512 21.1977 22.8948 20.5848 22.8948H3.41625C2.80331 22.8948 2.21561 22.6512 1.78233 22.218C1.3489 21.7846 1.10547 21.1968 1.10547 20.584V5.75658C1.10547 5.14371 1.34894 4.55595 1.78229 4.1226C2.21564 3.68927 2.80338 3.4458 3.41625 3.4458H5.78809V1.85498C5.78809 1.44077 6.12387 1.10498 6.53809 1.10498ZM16.7129 4.9458V6.53732C16.7129 6.95153 17.0487 7.28732 17.4629 7.28732C17.8771 7.28732 18.2129 6.95153 18.2129 6.53732V4.9458H20.5848C20.7999 4.9458 21.0061 5.03125 21.1581 5.18323C21.3102 5.33536 21.3956 5.54163 21.3956 5.75658V20.584C21.3956 20.799 21.3101 21.0053 21.1581 21.1573C21.0061 21.3093 20.7998 21.3948 20.5848 21.3948H3.41625C3.20129 21.3948 2.99502 21.3093 2.84289 21.1572C2.69092 21.0053 2.60547 20.799 2.60547 20.584V5.75658C2.60547 5.54155 2.69088 5.33534 2.84293 5.18328C2.99499 5.03123 3.20122 4.9458 3.41625 4.9458H5.78809V6.53732C5.78809 6.95153 6.12387 7.28732 6.53809 7.28732C6.9523 7.28732 7.28809 6.95153 7.28809 6.53732V4.9458H16.7129Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.1458 12.945C14.5038 12.945 14.8443 12.8699 15.1523 12.7346V16.7124H13.5605C13.1463 16.7124 12.8105 17.0482 12.8105 17.4624C12.8105 17.8766 13.1463 18.2124 13.5605 18.2124L15.9023 18.2124L18.2426 18.2124C18.6568 18.2124 18.9926 17.8766 18.9926 17.4624C18.9926 17.0482 18.6568 16.7124 18.2426 16.7124H16.6523V10.4392C16.6523 10.025 16.3166 9.68921 15.9023 9.68921H15.902H15.9016C15.4874 9.68921 15.1516 10.025 15.1516 10.4392C15.1516 10.9947 14.7013 11.445 14.1458 11.445H13.5605C13.1463 11.445 12.8105 11.7808 12.8105 12.195C12.8105 12.6092 13.1463 12.945 13.5605 12.945H14.1458Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.28868 11.4057C5.5687 10.4157 6.47819 9.68923 7.5593 9.68921H8.43724C8.43725 9.68921 8.43724 9.68921 8.43724 9.68921C9.74039 9.68919 10.7968 10.7456 10.7968 12.0488C10.7968 12.6189 10.5946 13.1419 10.2579 13.5498C10.7684 14.0085 11.0895 14.6739 11.0895 15.4142V15.7068C11.0895 17.0908 9.96754 18.2127 8.58358 18.2127H7.41301C6.32071 18.2127 5.39356 17.5142 5.04992 16.5421C4.91187 16.1515 5.11655 15.723 5.50708 15.585C5.89762 15.4469 6.32612 15.6516 6.46416 16.0422C6.60262 16.4339 6.97625 16.7127 7.41301 16.7127H8.58358C9.13911 16.7127 9.58946 16.2624 9.58946 15.7068V15.4142C9.58946 14.8587 9.13911 14.4083 8.58358 14.4083H7.9983C7.58409 14.4083 7.2483 14.0725 7.2483 13.6583C7.2483 13.2441 7.58409 12.9083 7.9983 12.9083H8.43727C8.91197 12.9083 9.29681 12.5235 9.29681 12.0488C9.29681 11.574 8.91196 11.1892 8.43727 11.1892H7.55933C7.55933 11.1892 7.55934 11.1892 7.55933 11.1892C7.16698 11.1892 6.83422 11.4527 6.73206 11.8139C6.61932 12.2125 6.20482 12.4442 5.80624 12.3315C5.40766 12.2187 5.17595 11.8042 5.28868 11.4057Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconCalendarNumber.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconCalendarNumber.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconCalendarNumber.prototype, "size", void 0);
if (customElements.get('cat-icon-calendar-number') === undefined) {
    customElements.define('cat-icon-calendar-number', BlocksIconCalendarNumber);
}
